module.exports = __webpack_public_path__ + "static/about-paper-2681a55b69b05feaa7667cad2749d68d.png";